<template>
  <div class="form-group with-icon-right-mod">
    <div class="input-group">
      <input @input="debounceInput" :type="typeInput" :id="idInput" :name="idInput" :value="inputValue" autocomplete="off" :min="min" :maxlength="maxlength" :max="max" required v-if="inputMask === null" :disabled="inputDisabled"/>
      <the-mask @input="debounceInput" :type="typeInput" :id="idInput" :name="idInput" :value="inputValue" autocomplete="off" :mask="inputMask" required v-if="inputMask !== null" :disabled="inputDisabled"/>
      <i :class="'fa icon-left input-icon '+iconInput"></i>
      <i class="fa fa-times icon-right input-icon pointer" @click="clear()"></i>
      <label class="control-label" :for="idInput">{{labelInput}}</label><i class="bar"></i>
      <small class="help text-secondary">
        <slot></slot>
      </small>
    </div>
  </div>
</template>

<script>
window._ = require('lodash')

import { TheMask } from 'vue-the-mask'
export default {
  name: 'InputIconGroup',
  components: { TheMask },
  props: {
    min: {
      type: Number
    },
    max: {
      type: Number
    },
    maxlength: {
      type: Number
    },
    idInput: {
      type: String,
      required: true
    },
    iconInput: {
      type: String,
      required: true
    },
    labelInput: {
      type: String,
      required: true
    },
    typeInput: {
      type: String,
      required: false,
      default: function () {
        return 'text'
      }
    },
    inputMask: {
      type: Array,
      required: false,
      default: function () {
        return null
      }
    },
    inputDisabled: {
      type: String,
      required: false,
      default: function () {
        return null
      }
    },
    inputValue: {
      type: String,
      required: false,
      default: function () {
        return null
      },
    },
  },
  methods: {
    clear () {
      document.getElementById(this.idInput).value = ''
    },
    debounceInput: _.debounce(function (e) {
      let value = document.getElementById(this.idInput).value
      this.$emit('change', value)
    }, 1000),
  }
}
</script>

<style scoped>

</style>
